import { createReducer, on } from '@ngrx/store';
import { currentDisplayedPagesReported, downloadPageStarted, downloadPageCompleted } from './data-access-page.actions';
import { PageData } from './data-access-page.model';

export const PAGE_FEATURE_KEY = 'page';

export interface PageState {
  currentPages: PageData[];
  loaded: boolean;
  isDownloading: boolean;
}

export const initialState: PageState = {
  currentPages: [],
  loaded: true,
  isDownloading: false,
};

export const pageReducer = createReducer(
  initialState,
  on(currentDisplayedPagesReported, (state, { pages }) => {
    /**
     * Pages may be reported multiple times with different infos (on report contains products, one contains toc)
     * Therefore we combine existing data with same IDs
     */
    return {
      ...state,
      loaded: true,
      currentPages: pages.map((newPageData) => {
        const oldPageData = state.currentPages.find((page) => page.id === newPageData.id);
        if (oldPageData) {
          return { ...oldPageData, ...newPageData };
        } else {
          return newPageData;
        }
      }),
    };
  }),
  on(downloadPageStarted, (state) => ({
    ...state,
    isDownloading: true,
  })),
  on(downloadPageCompleted, (state) => ({
    ...state,
    isDownloading: false,
  }))
);
